import { DryRunReduceResult, round } from '@kunalabs-io/kai'
import Decimal from 'decimal.js'

import { ReductionInfoSubmit } from '../types'

export const SMALL_PCT_ROUNDED = '(0.00%)'

export const getPercentageChange = (a: Decimal, b: Decimal): Decimal | undefined => {
  if (a.isZero()) {
    return undefined
  }

  return b.minus(a).dividedBy(a).times(100)
}

export const formatPercentage = (decimal: Decimal, decimals = 2): string => {
  const threshold = new Decimal(0.5).dividedBy(new Decimal(10).pow(decimals))

  if (decimal.abs().lessThan(threshold)) {
    return SMALL_PCT_ROUNDED
  }

  return `(${!decimal.isZero() && decimal.isPositive() ? '+' : ''}${decimal.toFixed(decimals)}%)`
}

export const getMaxHeightForAdditionalContent = (pendingRewardsNum: number) => {
  const baseHeight = 450
  const baseRewardNum = 2
  const additionalRewardHeight = 44

  if (pendingRewardsNum <= baseRewardNum) {
    return baseHeight
  }

  return baseHeight + (pendingRewardsNum - baseRewardNum) * additionalRewardHeight
}

export const isSwapAvailable = (
  isCalculatingDryRun: boolean,
  reductionInfoSubmit: ReductionInfoSubmit,
  dryRunResult?: DryRunReduceResult
) => {
  const showDryRunResult = !isCalculatingDryRun && dryRunResult
  let noSwap

  if (showDryRunResult) {
    noSwap = dryRunResult.swapX.toDecimal().isZero() && dryRunResult.swapY.toDecimal().isZero()
  } else {
    noSwap = reductionInfoSubmit.swapX.isZero() && reductionInfoSubmit.swapY.isZero()
  }

  return !noSwap
}
